import React from "react";
import "../Styles/QueryModal.css";

const QueryModal = ({ isOpen, onClose, onSubmit }) => {
  const [formData, setFormData] = React.useState({
    title: "",
    category: "",
    course: "all",
    priority: "medium",
    description: "",
    attachment: null,
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(formData);
    setFormData({
      title: "",
      category: "",
      course: "all",
      priority: "medium",
      description: "",
      attachment: null,
    });
  };

  const handleChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h3 className="modal-title">Submit New Query</h3>
          <button className="close-modal" onClick={onClose}>
            &times;
          </button>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="queryTitle">Query Title</label>
            <input
              type="text"
              id="queryTitle"
              className="form-control"
              placeholder="Brief description of your issue"
              value={formData.title}
              onChange={(e) => handleChange("title", e.target.value)}
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="queryCategory">Category</label>
            <select
              id="queryCategory"
              className="form-control"
              value={formData.category}
              onChange={(e) => handleChange("category", e.target.value)}
              required
            >
              <option value="">Select Category</option>
              <option value="Project Submission">Project Submission</option>
              <option value="Help">Help</option>
              <option value="Refferal">Refferal</option>
            </select>
          </div>

          <div className="form-group">
            <label htmlFor="queryCourse">Related Course</label>
            <select
              id="queryCourse"
              className="form-control"
              value={formData.course}
              onChange={(e) => handleChange("course", e.target.value)}
            >
              <option value="all">Not specific to a course</option>
              <option value="intro">Introduction to Qodify</option>
              <option value="advanced">Advanced Techniques</option>
              <option value="integration">Integration Methods</option>
            </select>
          </div>

          <div className="form-group">
            <label htmlFor="queryPriority">Priority</label>
            <select
              id="queryPriority"
              className="form-control"
              value={formData.priority}
              onChange={(e) => handleChange("priority", e.target.value)}
              required
            >
              <option value="low">Low</option>
              <option value="medium">Medium</option>
              <option value="high">High</option>
            </select>
          </div>

          <div className="form-group">
            <label htmlFor="queryDescription">Detailed Description</label>
            <textarea
              id="queryDescription"
              className="form-control"
              placeholder="Please provide as much detail as possible about your query..."
              value={formData.description}
              onChange={(e) => handleChange("description", e.target.value)}
              required
            ></textarea>
          </div>

          <div className="form-group">
            <label htmlFor="queryAttachment">Attachments (Optional)</label>
            <input
              type="file"
              id="queryAttachment"
              className="form-control"
              onChange={(e) => handleChange("attachment", e.target.files[0])}
            />
          </div>

          <div className="form-actions">
            <button type="button" className="btn btn-outline" onClick={onClose}>
              Cancel
            </button>
            <button type="submit" className="btn btn-primary">
              Submit Query
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default QueryModal;
